import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { Container, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getISTDate, getMonthYear, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { STOCK_STATUS_REPORT } from '../../../../../constants/dropdown';
import { SelectDoctorTable } from '../../HMS/masters/others/SelectDoctorTable';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export const ProductInfo = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [input, setInput] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [location, setLocation] = useState([]);
  const [product, setProduct] = useState([]);
  const [group, setGroup] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [category, setCategory] = useState([]);
  const [salt, setSalt] = useState([]);
  const [productids, setProductIds] = useState('');
  const [grouptids, setGroupIds] = useState('');
  const [subgroupids, setSubgroupids] = useState('');
  const [categoryIds, setCategoryIds] = useState('');
  const [saltIds, setSaltIds] = useState('');
  const [loading,setLoading] = useState(false);
  const [expiredItems,setExpiredItems] = useState([]);
  const [topSellingProducts,setTosellingProducts] = useState([])
  const [leastSellingProducts,setLeastSellingProducts] = useState([])


  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getISTDate()
    },
    mode: 'all'
  });

  const { watch, setValue } = methods;

  const EXPIRED_PRODUCT_HEADER = [
    { header: 'Product Name', 
      accessor: (row) => row?.product_name
    },
    { header: 'Location', 
      accessor: (row) => row?.location_name 
    },
    { header: 'Batch', 
      accessor: (row) => row?.batch_no
    },
    { header: 'Exp Date', 
      accessor: (row) => getMonthYear(row?.exp_date)
    },
    { header: 'Qty', 
      accessor: (row) => row?.total_qty
    },
    { header: 'No of Days', 
      accessor: (row) => row?.days_expired
    },
  ]
 
    const TOP_SELLING_PRODUCT_HEADER = [
    { header: 'Product Name', 
      accessor: (row) => row?.product_name
    },
    { header: 'Qty', 
      accessor: (row) => row?.total_sold_qty
    },
    { header: 'Stock', 
      accessor: (row) => row?.totalStock
    },
  ]

  const TOP_LEAST_SELLING_PRODUCT_HEADER = [
    { header: 'Product Name', 
      accessor: (row) => row?.product_name
    },
    { header: 'Qty', 
      accessor: (row) => row?.total_sold_qty
    },
    { header: 'Stock', 
      accessor: (row) => row?.totalStock
    },
  ]



  const isSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  useEffect(() => {
    const totalBillQty = selectedRows.reduce((acc, item) => acc + item.bill_qty, 0);
    setValue('bill_qty', totalBillQty);
  }, [selectedRows]);


  const limit = 10;
  const filterBy = watch('filter_by');
  const watchLocation = watch('location');
  useEffect(() => {
    setSelectedRows([]);
  }, [filterBy]);

  const getProductDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${limit}`);
    setProduct(response.data);
  }, []);

  const getGroupDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/pharmacy-group/dropdown?limit=${limit}`);
    setGroup(response.data);
  }, []);

  const getSubGroupDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/pharmacy-subgroup/dropdown?limit=${limit}`);
    setSubGroup(response.data);
  }, []);

  const getCategoryDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/product-category/dropdown?limit=${limit}`);
    setCategory(response.data);
  }, []);

  const getSaltDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/generic-master/dropdown?limit=${limit}`);
    setSalt(response.data);
  }, []);

  const searchProducts = useCallback(async () => {
    const lowercasedInput = String(input).toLowerCase();
    const response = await axios.get(`${BASE_URL}/product-master/dropdown?name=${lowercasedInput}&limit=${limit}`);
    setProduct(response.data);
  }, [input]);

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  useEffect(() => {
    if (filterBy === 'PRODUCT NAME') {
      getProductDropdown();
    }
  }, [filterBy, getProductDropdown]);

  useEffect(() => {
    if (filterBy === 'GROUP') {
      getGroupDropdown();
    }
  }, [filterBy, getGroupDropdown]);

  useEffect(() => {
    if (filterBy === 'SUBGROUP') {
      getSubGroupDropdown();
    }
  }, [filterBy, getSubGroupDropdown]);

  useEffect(() => {
    if (filterBy === 'CATEGORY NAME') {
      getCategoryDropdown();
    }
  }, [filterBy, getCategoryDropdown]);

  useEffect(() => {
    if (filterBy === 'SALT NAME') {
      getSaltDropdown();
    }
  }, [filterBy, getSaltDropdown]);

  useEffect(() => {
    if (filterBy === 'PRODUCT NAME') {
      searchProducts();
    }
  }, [filterBy, input, searchProducts]);

  useEffect(() => {
    const ids = selectedRows.map((item) => item._id).join(',');
    switch (filterBy) {
      case 'PRODUCT NAME':
        setProductIds(ids);
        break;
      case 'GROUP':
        setGroupIds(ids);
        break;
      case 'SUBGROUP':
        setSubgroupids(ids);
        break;
      case 'CATEGORY NAME':
        setCategoryIds(ids);
        break;
      default:
        setSaltIds(ids);
    }
  }, [selectedRows, filterBy]);

  const handleExcelReportByProduct = async () => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const ids = selectedRows.map((item) => item._id).join(',');
    if (ids.length === 0) {
      toast('Please Select Any Item First', { variant: 'warning' });
      return;
    }

    const refId = {
      name: ids,
      location: watchLocation,
      from_date: watch('from_date'),
      to_date: watch('to_date')
    };

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/product-ledger?refId=${encodeURIComponent(JSON.stringify(refId))}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      if (stockData && stockData.length > 0) {
        let formattedTransactionData = [];

        stockData.forEach((item) => {
          const productName = item?.productInfo?.main?.name || '';
          const transactions = item?.transactions || [];

          transactions.forEach((txn, index) => {
            formattedTransactionData.push({
              'Sr. No.': formattedTransactionData.length + 1,
              'Product Name': productName,
              'Date': txn.date ? new Date(txn.date).toLocaleDateString() : '',
              'Doc No': txn.doc_no,
              'Type': txn.type || '',
              'InQty': txn.inQty ?? 0,
              'OutQty': txn.outQty ?? 0,
              'Batch No': txn.batch_no || '',
              'Expiry Date': txn.exp_date ? new Date(txn.exp_date).toLocaleDateString() : '',
              'Rate': txn.purRate ?? 0,
              'Amount': txn.purAmount ?? 0
            });
          });
        });

        const fileName = `Product_Ledger_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedTransactionData);
        ws['!cols'] = [
          { wch: 8 },  // Sr. No.
          { wch: 30 }, // Product Name
          { wch: 15 }, // Date
          { wch: 15 }, // Type
          { wch: 10 }, // InQty
          { wch: 10 }, // OutQty
          { wch: 15 }, // Batch No
          { wch: 15 }, // Expiry Date
          { wch: 10 }, // Rate
          { wch: 15 }  // Amount
        ];

        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
};


  const handleExcelReportByGroup = async () => {
   const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const ids = selectedRows.map((item) => item._id).join(',');
    if (ids.length === 0) {
      toast('Please Select Any Item First', { variant: 'warning' });
      return;
    }

    const refId = {
      group: ids,
      location: watchLocation,
      from_date: watch('from_date'),
      to_date: watch('to_date')
    };

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/product-ledger/group?refId=${encodeURIComponent(JSON.stringify(refId))}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      if (stockData && stockData.length > 0) {
        let formattedTransactionData = [];

        stockData.forEach((item) => {
          const productName = item?.productInfo?.main?.name || '';
          const transactions = item?.transactions || [];

          transactions.forEach((txn, index) => {
            formattedTransactionData.push({
              'Sr. No.': formattedTransactionData.length + 1,
              'Product Name': productName,
              'Date': txn.date ? new Date(txn.date).toLocaleDateString() : '',
              'Doc No': txn.doc_no,
              'Type': txn.type || '',
              'InQty': txn.inQty ?? 0,
              'OutQty': txn.outQty ?? 0,
              'Batch No': txn.batch_no || '',
              'Expiry Date': txn.exp_date ? new Date(txn.exp_date).toLocaleDateString() : '',
              'Rate': txn.purRate ?? 0,
              'Amount': txn.purAmount ?? 0
            });
          });
        });

        const fileName = `Product_Ledgers_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedTransactionData);
        ws['!cols'] = [
          { wch: 8 },  // Sr. No.
          { wch: 30 }, // Product Name
          { wch: 15 }, // Date
          { wch: 15 }, // Doc No.
          { wch: 15 }, // Type
          { wch: 10 }, // InQty
          { wch: 10 }, // OutQty
          { wch: 15 }, // Batch No
          { wch: 15 }, // Expiry Date
          { wch: 10 }, // Rate
          { wch: 15 }  // Amount
        ];

        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
  };

  const handleExcelReportBySubGroup = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const ids = selectedRows.map((item) => item._id).join(',');
    if (ids.length === 0) {
      toast('Please Select Any Item First', { variant: 'warning' });
      return;
    }

    const refId = {
      sub_group: ids,
      location: watchLocation,
      from_date: watch('from_date'),
      to_date: watch('to_date')
    };

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/product-ledger/subgroup?refId=${encodeURIComponent(JSON.stringify(refId))}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      if (stockData && stockData.length > 0) {
        let formattedTransactionData = [];

        stockData.forEach((item) => {
          const productName = item?.productInfo?.main?.name || '';
          const transactions = item?.transactions || [];

          transactions.forEach((txn, index) => {
            formattedTransactionData.push({
              'Sr. No.': formattedTransactionData.length + 1,
              'Product Name': productName,
              'Date': txn.date ? new Date(txn.date).toLocaleDateString() : '',
              'Doc No': txn.doc_no,
              'Type': txn.type || '',
              'InQty': txn.inQty ?? 0,
              'OutQty': txn.outQty ?? 0,
              'Batch No': txn.batch_no || '',
              'Expiry Date': txn.exp_date ? new Date(txn.exp_date).toLocaleDateString() : '',
              'Rate': txn.purRate ?? 0,
              'Amount': txn.purAmount ?? 0
            });
          });
        });

        const fileName = `Product_Ledgers_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedTransactionData);
        ws['!cols'] = [
          { wch: 8 },  // Sr. No.
          { wch: 30 }, // Product Name
          { wch: 15 }, // Date
          { wch: 15 }, // Doc No.
          { wch: 15 }, // Type
          { wch: 10 }, // InQty
          { wch: 10 }, // OutQty
          { wch: 15 }, // Batch No
          { wch: 15 }, // Expiry Date
          { wch: 10 }, // Rate
          { wch: 15 }  // Amount
        ];

        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
  };

  const handleExcelReportByCategory = async () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const ids = selectedRows.map((item) => item._id).join(',');
    if (ids.length === 0) {
      toast('Please Select Any Item First', { variant: 'warning' });
      return;
    }

    const refId = {
      category: ids,
      location: watchLocation,
      from_date: watch('from_date'),
      to_date: watch('to_date')
    };

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/product-ledger/category?refId=${encodeURIComponent(JSON.stringify(refId))}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      if (stockData && stockData.length > 0) {
        let formattedTransactionData = [];

        stockData.forEach((item) => {
          const productName = item?.productInfo?.main?.name || '';
          const transactions = item?.transactions || [];

          transactions.forEach((txn, index) => {
            formattedTransactionData.push({
              'Sr. No.': formattedTransactionData.length + 1,
              'Product Name': productName,
              'Date': txn.date ? new Date(txn.date).toLocaleDateString() : '',
              'Doc No': txn.doc_no,
              'Type': txn.type || '',
              'InQty': txn.inQty ?? 0,
              'OutQty': txn.outQty ?? 0,
              'Batch No': txn.batch_no || '',
              'Expiry Date': txn.exp_date ? new Date(txn.exp_date).toLocaleDateString() : '',
              'Rate': txn.purRate ?? 0,
              'Amount': txn.purAmount ?? 0
            });
          });
        });

        const fileName = `Product_Ledgers_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedTransactionData);
        ws['!cols'] = [
          { wch: 8 },  // Sr. No.
          { wch: 30 }, // Product Name
          { wch: 15 }, // Date
          { wch: 15 }, // Type
          { wch: 10 }, // InQty
          { wch: 10 }, // OutQty
          { wch: 15 }, // Batch No
          { wch: 15 }, // Expiry Date
          { wch: 10 }, // Rate
          { wch: 15 }  // Amount
        ];
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
  };

  const handleExcelReportBySalt = async () => {
          const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const ids = selectedRows.map((item) => item._id).join(',');
    if (ids.length === 0) {
      toast('Please Select Any Item First', { variant: 'warning' });
      return;
    }

    const refId = {
      salt: ids,
      location: watchLocation,
      from_date: watch('from_date'),
      to_date: watch('to_date')
    };

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/product-ledger/salt?refId=${encodeURIComponent(JSON.stringify(refId))}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      if (stockData && stockData.length > 0) {
        let formattedTransactionData = [];

        stockData.forEach((item) => {
          const productName = item?.productInfo?.main?.name || '';
          const transactions = item?.transactions || [];

          transactions.forEach((txn, index) => {
            formattedTransactionData.push({
              'Sr. No.': formattedTransactionData.length + 1,
              'Product Name': productName,
              'Date': txn.date ? new Date(txn.date).toLocaleDateString() : '',
              'Doc No': txn.doc_no,
              'Type': txn.type || '',
              'InQty': txn.inQty ?? 0,
              'OutQty': txn.outQty ?? 0,
              'Batch No': txn.batch_no || '',
              'Expiry Date': txn.exp_date ? new Date(txn.exp_date).toLocaleDateString() : '',
              'Rate': txn.purRate ?? 0,
              'Amount': txn.purAmount ?? 0
            });
          });
        });

        const fileName = `Product_Ledgers_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedTransactionData);
        ws['!cols'] = [
          { wch: 8 },  // Sr. No.
          { wch: 30 }, // Product Name
          { wch: 15 }, // Date
          { wch: 15 }, // Type
          { wch: 10 }, // InQty
          { wch: 10 }, // OutQty
          { wch: 15 }, // Batch No
          { wch: 15 }, // Expiry Date
          { wch: 10 }, // Rate
          { wch: 15 }  // Amount
        ];

        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
  };


    useEffect(() => {
      const fetchRevenue = async () => {
        setLoading(true);
        try {
          const response = await request('/total-expired-products-list', { method: 'GET' });
          if (response?.success) {
            setExpiredItems(response.data)
          } else {
            toast('Failed to load revenue', { variant: 'error' });
          }
        } catch (error) {
          console.error('Error fetching Data:', error);
          toast('Error fetching revenue', { variant: 'error' });
        } finally {
          setLoading(false);
        }
      };
      fetchRevenue();
    }, []);

        useEffect(() => {
      const fetchRevenue = async () => {
        setLoading(true);
        try {
          const response = await request('/top-selling-product-list', { method: 'GET' });
          if (response?.success) {
            setTosellingProducts(response.data)
          } else {
            toast('Failed to load revenue', { variant: 'error' });
          }
        } catch (error) {
          console.error('Error fetching Data:', error);
          toast('Error fetching revenue', { variant: 'error' });
        } finally {
          setLoading(false);
        }
      };
      fetchRevenue();
    }, []);


            useEffect(() => {
              const fetchRevenue = async () => {
                setLoading(true);
                try {
                  const response = await request('/least-selling-product-list', { method: 'GET' });
                  if (response?.success) {
                    setLeastSellingProducts(response.data);
                  } else {
                    toast('Failed to load revenue', { variant: 'error' });
                  }
                } catch (error) {
                  console.error('Error fetching Data:', error);
                  toast('Error fetching revenue', { variant: 'error' });
                } finally {
                  setLoading(false);
                }
              };
              fetchRevenue();
            }, []);



  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Grid container spacing={2} sx={{ marginTop: '2%' }}>
              <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography sx={{fontSize:"12px",fontWeight:"bold"}}>Expired Items Details</Typography>
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={expiredItems || []}
                    columns={EXPIRED_PRODUCT_HEADER}
                    size="small"
                  />
              </Grid>
                 <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                   <Typography sx={{fontSize:"12px",fontWeight:"bold"}}>Top 100 Selling Items</Typography>
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={topSellingProducts || []}
                    columns={TOP_SELLING_PRODUCT_HEADER}
                    size="small"
                  />
              </Grid>
                 <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                   <Typography sx={{fontSize:"12px",fontWeight:"bold"}}>Top 100 Least Selling Items</Typography>
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={leastSellingProducts || []}
                    columns={TOP_LEAST_SELLING_PRODUCT_HEADER}
                    size="small"
                  />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
